import { Team__Omega } from "../teams/Omega";
import { Team__Abejas } from "../teams/Abejas";

const Abejas = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 53,
  penaltyGoals: 0,
  isWinner: false,
};

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Abejas,
      team2: Omega,

      isCompleted: true,
      isPlaying: false,
      day: "Sábado",
      date: "2026-08-01",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
